import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppShell from "./layout/AppShell";
import ViewLeadViaToken from "./pages/ViewLeadViaToken";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AppShell />} />
        <Route path="/admin" element={<AppShell />} />
        <Route path="/admin/products" element={<AppShell />} />
        <Route path="/admin/users" element={<AppShell />} />
        <Route path="/admin/analytics" element={<AppShell />} />
        <Route path="/admin/leads/view/:token" element={<ViewLeadViaToken />} />
      </Routes>
    </BrowserRouter>
  );
}

